import useForceUpdate from './useForceUpdate';
import { useEffect, useRef } from 'react';
import FJConstant from '../constants/FJConstant';
import FJLocalStore from '../store/FJLocalStore';
import FJEvent from '../store/FJEvent.js';

function useLocalStore() {
    const fecundateRef = useRef(useForceUpdate());
    const forceUpdate = fecundateRef.current;
    const isHasLanguageData = !!FJLocalStore.language();

    useEffect(() => {
        try {
            const isNowHasLanguageData = !!FJLocalStore.language();
            if (isHasLanguageData !== isNowHasLanguageData) {
                fecundateRef();
            }
        } catch (e) {
            console.log(e);
        }
    }, []);

    useEffect(() => {
        return FJEvent.subscribe(FJConstant.LANGUAGE_CHANGED, forceUpdate);
    }, [forceUpdate]);
}

export default useLocalStore;
